<template>
  <div class="bgf4">
    <div class="abc">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <div class="fleft  cleft">
        <!-- <div class="firmTitle bgblue">
          <img src="../../images/jt.png">
          <span style="margin-left:10px">水产委会概况</span>
        </div> -->
        <ul class="cleftUl">
          <a-menu mode="inline" :open-keys.sync="openKeys"  @click="handleClick" class="mezt" :default-selected-keys="openKeys1">
                <template v-for="i in treeList" style="display: none;">
                  <a-menu-item class="ali"
                    :key="i.id"
                  >
                    <span>{{ i.commtitle }}</span>
                  </a-menu-item>
                </template>
          </a-menu>
        </ul>
      </div>
      <div class="fright  cright" >
        <h3 class="qytr">
          <span class="blueBlock"></span>
          {{scwh.commtitle}}
        </h3>
        <div v-html="desc" style="margin-top:20px">
        </div>
      </div>
    </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  data(){
    return{
      locale: zhCN,
      treeList: [
      ],
      openKeys:[],
      openKeys1:[],
      scwh:{},
      desc:''
    }
  },
  computed:{

  },
  created(){
    this.query()
  },
  mounted () {

  },
  watch: {
  },
  methods: {
    handleClick(e){
      this.queryById(e.key)
    },
    queryById(value){
      http.get('/queryByIdScwh',{params:{id:value}}
      ).then((res) => {
          this.scwh=res.data.result
          this.desc = this.scwh.content
      })
    },
    query(){
      http.get('/queryAllScwh',{}
      ).then((res) => {
          this.treeList = res.data.result
          this.openKeys1.push(this.treeList[0].id)
          this.queryById(this.treeList[0].id)
      })
    },
  },
}
</script>


<style scoped>
@import "../../config/AquaticCommission.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticcommission/AquaticCommission.vue